import React from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";

function Header() {
  const navigate = useNavigate();

  const isLoginVisible = () => {
    if (window.location.pathname === Paths.login) {
      return false;
    }
    return true;
  };

  const isSignupVisible = () => {
    if (window.location.pathname === Paths.signup) {
      return false;
    }
    return true;
  };

  const handleLogoPress = () => {
    navigate(Paths.home);
  };

  const handleLogin = () => {
    navigate(Paths.login);
  };

  const handleGetStarted = () => {
    navigate(Paths.signup);
  };

  return (
    <div className={ClassName.container}>
      <div className={ClassName.content}>
        <div className={ClassName.logoContainer} onClick={handleLogoPress}>
          <img src="/logo.svg" alt="logo" className={ClassName.logo} />
        </div>
        <div className={ClassName.menuItems}></div>
        <div className={ClassName.authenticationItems}>
          {isLoginVisible() && (
            <div onClick={handleLogin} className={ClassName.login}>
              Login
            </div>
          )}
          {isSignupVisible() && (
            <div onClick={handleGetStarted} className={ClassName.signUpButton}>
              Get Started
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;

const ClassName = {
  container:
    "w-screen fixed flex items-center justify-center bg-white shadow-sm z-50",
  content:
    "w-full max-w-7xl flex items-center justify-between py-4 px-2 xl:px-0",
  logoContainer: "cursor-pointer",
  logo: "h-5 lg:h-9 object-contain",
  menuItems: "flex items-center gap-6 cursor-pointer",
  menuName: "text-secondaryText group-hover:text-primary font-bold py-6",
  productMenu: "flex items-center relative group",
  useCaseMenu: "flex items-center relative group",
  pricingMenu: "flex items-center relative group",
  helpMenu: "flex items-center relative group",
  companyMenu: "flex items-center relative group",
  chevronContainer: "w-5 h-5 flex items-center justify-center",
  chevronDown: "w-3 object-contain flex group-hover:hidden",
  chevronUp: "w-3 object-contain hidden group-hover:flex",

  authenticationItems: "flex items-center cursor-pointer gap-2 lg:gap-6",
  login: "font-bold text-primary text-sm lg:text-base",
  signUpButton:
    "bg-primary text-sm lg:text-base font-bold text-white rounded-lg  px-4 lg:px-6 py-2",
};
